import * as React from 'react';
import {ClientBrowsingHistory} from "../../../../domain/model/client_browsing_history";
import {Customer} from "../../../../domain/model/customer";
import ScoutCustomerCard from "../../../common/organism/card/scout_customer_card";
import styled from "styled-components";
import {TJobCareerWithCustomerID} from "../../../../domain/repository/job_career_repository";
import {JobCareer} from "../../../../domain/model/job_career";
import {TPagination} from "../../../type/common";
import Pagination from "../../../common/molecular/pagination/pagination";
import {ClientBookmark} from "../../../../domain/model/client_bookmark";

interface IProps {
    clientBrowsingHistories: ClientBrowsingHistory[];
    customers: Customer[];
    jobCareersWithCustomerID: TJobCareerWithCustomerID[],
    clientBookmarks: ClientBookmark[],
    paginationPrams: TPagination
}

const ClientClientBrowsingHistoriesMain: React.FC<IProps> = (props) => {

    const {clientBrowsingHistories, customers, jobCareersWithCustomerID, clientBookmarks, paginationPrams} = props;

    // Customerの連想配列を作成し、customerIDから連携させる。
    const hashCustomer: { [customerId: string]: Customer; } = {};
    for (const item of customers) {
        hashCustomer[item.id] = item;
    }

    // customerId: JobCareer[]の連想配列を作成し連携させる。
    const hashJobCareer: { [customerId: string]: JobCareer[]; } = {};
    for (const item of jobCareersWithCustomerID) {
        hashJobCareer[item.customerID] = item.jobCareers;
    }

    const res: JSX.Element = (
        <React.Fragment>
            {
                clientBrowsingHistories.map((clientBrowsingHistory: ClientBrowsingHistory, index) => {
                    const customer: Customer | undefined = hashCustomer[clientBrowsingHistory.customerID];
                    if (!customer) {return null};
                    const customerId: string = customer.id;
                    const jobCareers: JobCareer[] | undefined = hashJobCareer[customerId];
                    if (!jobCareers) {return null};
                    const isBookmarked: boolean = clientBookmarks.some((clientBookmark: ClientBookmark) => {
                        return clientBookmark.customerID === customerId
                    });
                    return (
                        <ScoutCustomerCardWrapper key={index}>
                            <ScoutCustomerCard
                                customer={customer}
                                jobCareers={jobCareers}
                                isBookmarked={isBookmarked}
                                cardURL={`/client/scout/customer/${customerId}`}
                            />
                        </ScoutCustomerCardWrapper>
                    )
                })
            }
            <Pagination paginationPrams={paginationPrams} />
        </React.Fragment>

    );

    return (res);

};

export default ClientClientBrowsingHistoriesMain;

const ScoutCustomerCardWrapper = styled.div`
    margin-bottom: 40px;
`;


// WEBPACK FOOTER //
// ./src/presentation/component/client/client_browsing_histories/client_browsing_histories_main.tsx